// @flow

import BaseComponent from './abstract/BaseComponent';
import EventNames from '../constants/EventNames';
import InputTypes from '../constants/InputTypes';

export default class TogglePassword extends BaseComponent {
  #clickHandler: function;
  input: HTMLElement;
  trigger: HTMLElement;

  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.setUp();

    this.#clickHandler = this.onClick.bind(this);
    this.trigger.addEventListener(EventNames.CLICK, this.#clickHandler);
  }

  /**
   * Validate and set properties
   */
  setUp(): void {
    this.setProperties(['input', 'trigger']);
  }

  /**
   * Toggle the password on click
   */
  onClick(e: Event): void {
    e.preventDefault();
    this.toggleInputType();
    this.toggleIcons();
  }

  /**
   * Toggles the input type
   */
  toggleInputType(): void {
    if (this.input.getAttribute('type') === InputTypes.PASSWORD) {
      this.input.setAttribute('type', InputTypes.TEXT);
    } else {
      this.input.setAttribute('type', InputTypes.PASSWORD);
    }
  }

  /**
   * Toggle the translations
   */
  toggleIcons(): void {
    const icon: SVGAElement | null = this.el.getElementByRef('icon');
    if (!icon) return;

    if (icon.getAttribute('href') === '#icon-show') {
      icon.setAttribute('href', '#icon-hide');
    } else {
      icon.setAttribute('href', '#icon-show');
    }
  }

  /**
   * Destroy all event listeners
   */
  destroy(): void {
    this.trigger.removeEventListener(EventNames.CLICK, this.#clickHandler);
    super.destroy();
  }
}
